'use client'

import { Avatar } from '@/components/ui/avatar'
import { Box } from '@chakra-ui/react'
import Image from 'next/image'
import React from 'react'
import { HeaderLogoConfig } from '../../_utils/getHeaderLogoConfig'

interface HeaderLogoProps {
  config: Pick<
    HeaderLogoConfig,
    'logoSrc' | 'useHorizontalLogo' | 'shipperName'
  >
  variant?: 'mobile' | 'desktop'
}

const HeaderLogo = ({ config, variant = 'mobile' }: HeaderLogoProps) => {
  const { logoSrc, useHorizontalLogo, shipperName } = config
  const maxWidth = variant === 'desktop' ? '200px' : '160px'

  if (logoSrc) {
    if (useHorizontalLogo) {
      return (
        <Box flexShrink={0}>
          <Image
            width={200}
            height={48}
            src={logoSrc}
            alt='logo'
            style={{
              height: '48px',
              width: 'auto',
              maxWidth,
              objectFit: 'contain',
              borderRadius: '12px',
            }}
          />
        </Box>
      )
    }

    return (
      <Box flexShrink={0}>
        <Image
          width={48}
          height={48}
          src={logoSrc}
          alt='logo'
          style={{
            borderRadius: '12px',
            width: '48px',
            height: '48px',
          }}
        />
      </Box>
    )
  }

  return (
    <Avatar
      flexShrink={0}
      name={shipperName}
      w='48px'
      height='48px'
      shape='square'
      rounded={12}
      size='lg'
      bg='background'
      color='text'
    />
  )
}

export default HeaderLogo
